<div
	class="mat-typography"
	[ngClass]="{ primary: color === 'primary', accent: color === 'accent' }"
>
	@switch (headerType) {
		@case ('1') {
			<h1 [ngClass]="{ bold: bold, center: center }">
				{{ title }}
				<span class="accent">{{ focusText }}</span>
			</h1>
		}
		@case ('2') {
			<h2 [ngClass]="{ bold: bold, center: center }">
				{{ title }}
			</h2>
		}
		@case ('3') {
			<h3 [ngClass]="{ bold: bold, center: center }">
				{{ title }}
			</h3>
		}
		@case ('4') {
			<h4 [ngClass]="{ bold: bold, center: center }">
				{{ title }}
			</h4>
		}
	}
</div>
